export const utilsConstants = {
  SET_SHOW_LOADER: "SET_SHOW_LOADER",
};
